import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';

import { requestLogin } from '../../../api/login/login.actions';

import { saveToLocalStorage, clearFromLocalStorage, retrieveFromLocalStorage } from '../../../utils/util';
import { startSession } from '../../../utils/session-timer';

import Login from '../../../components/screens/auth/login/Login';

const LoginContainer = () => {
  const [rememberUser, setRememberUser] = useState(false);
  const [mobile, setMobile] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMobile) {
      setMobile(true);
    }
  }, []);

  useEffect(() => {
    const checkIfUserIsLoggedIn = () => {
      const rememberUser = retrieveFromLocalStorage('rememberUser');
      setRememberUser(rememberUser);

      if (rememberUser) {
        const email = retrieveFromLocalStorage('email');
        const password = retrieveFromLocalStorage('password');

        if (email && password) {
          dispatch(
            requestLogin({
              input: { email, password },
              onSuccess: () => {
                startSession();
                navigate('/dashboard');
              },
            })
          );
        }
      }
    };

    checkIfUserIsLoggedIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logIn = (email, password, rememberMe) => {
    if (!email || !password) return;

    if (rememberMe) {
      saveToLocalStorage('email', email);
      saveToLocalStorage('password', password);
    } else {
      clearFromLocalStorage('email');
      clearFromLocalStorage('password');
    }

    saveToLocalStorage('rememberUser', rememberMe);

    dispatch(
      requestLogin({
        input: { email, password },
        onSuccess: () => {
          startSession();
          navigate('/dashboard');
        },
        navigate: navigate,
      })
    );
  };

  return <Login logIn={logIn} rememberUser={rememberUser} navigate={navigate} mobile={mobile} />;
};

export default LoginContainer;
